const videoToggle = function() {

    const statusVideo = function(e) {

        const _this = e.currentTarget;
        const _video = $(_this).closest('picture').find('video').attr('id');
        let videoElements = $('.gal-video');


        if ($("#" + _video).get(0).paused) {
            videoElements.each(function() {
                $(this).closest('picture').find('.video-control-btn').removeClass('in-play');
                this.pause(); // Pause the video
            });
            $("#" + _video).get(0).play();
        } else {
            $("#" + _video).get(0).pause();
        }




        /*         videoElements.each(function() {
                    console.log(this);
                    if (this.paused) {
                        this.play(); // Play the video
                        $(this).closest('picture').find('.video-control-btn').addClass('in-play');
                    } else {
                        $(this).closest('picture').find('.video-control-btn').removeClass('in-play');
                        this.pause(); // Pause the video
                    }
                }); */
    }

    return {

        init: () => {

                $('.video-control-btn').on('click', statusVideo);

            }
            // videoElements: videoElements
    }
}();

export default videoToggle;